const triggers = $('[data-toggle="survey-answer"]');
const targets = $('[data-answer]');
const npsModal = $('[data-survey].nps-modal');
const allowedNpsIds = ['nps_cards', 'nps_vex'];
import Alert from '../functions/GlobalAlerts';
const Lang = require('lang');

/**
 * Aplica os listeners necessários para a surveys
 */
function applySurveysEvents() {
  if (triggers.length > 0 && targets.length > 0) {
    surveyTabsEvents();
  }
  targets.hide();

  const isNpsAllowed = npsModal.toArray().some(item => allowedNpsIds.includes($(item).data('survey')));

  if (npsModal.length > 0 && isNpsAllowed) {
    npsSurveyEvents();
  }
}

function surveyTabsEvents() {
  triggers.on('click', function (e) {
    const id = $(this).data('target');
    const target = $(`[data-answer="${id.replace('#', '')}"]`);

    targets.hide();
    targets.find(':input').attr('disabled', 'disabled');

    target.fadeIn(200);
    target.find(':input').removeAttr('disabled');
  });
}

/**
 * Aplica os listeners necessários para a survey de nps
 */
function npsSurveyEvents() {
  const dontWantToAnswer = npsModal.find('.no-answer-nps');
  const answerLater = npsModal.find('.answer-later-nps');
  const sendAnswer = npsModal.find('.answer-send-nps');
  const comentary = npsModal.find('[name="comentario"]');
  const grade = npsModal.find('[name="nota"]');
  const idSurvey = npsModal.find('[name="id_nps_pesquisa"]').val();
  const form = npsModal.find('form');

  grade.on('change', function () {
    sendAnswer.prop('disabled', false);
  });

  comentary.on('change', function () {
    sendAnswer.prop('disabled', false);
  });

  sendAnswer.on('click', function (e) {
    e.preventDefault();

    nifty.body.overlay('show');

    const data = {
      id_nps_pesquisa: idSurvey,
      nota: parseInt(npsModal.find('[name="nota"]:checked').val()),
      comentario: comentary.val() || '',
      responder_depois: false
    };

    const request = $.ajax({
      method: 'POST',
      url: form.attr('action'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    });

    request.then(() => {
      Alert.createAndShow({
        message: Lang.get('js/src/survey/SurveyNps.answer_sent_success'),
        type: 'success'
      });

      npsModal.removeClass('show');
    }).catch(() => {
      Alert.createAndShow({
        message: Lang.get('js/src/survey/SurveyNps.answer_sent_error'),
        type: 'danger'
      });
    });

    nifty.body.overlay('hide');
  });

  dontWantToAnswer.on('click', function (e) {
    e.preventDefault();

    const data = {
      id_nps_pesquisa: idSurvey,
      nota: null,
      comentario: null,
      responder_depois: false
    }

    const request = $.ajax({
      method: 'POST',
      url: form.attr('action'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    });

    request.then(() => {
      npsModal.removeClass('show');
    }).catch(() => {
      Alert.createAndShow({
        message: Lang.get('js/src/survey/SurveyNps.answer_sent_error'),
        type: 'danger'
      });
    });
  });

  answerLater.on('click', function (e) {
    e.preventDefault();

    const data = {
      id_nps_pesquisa: idSurvey,
      nota: null,
      comentario: null,
      responder_depois: true
    };

    const request = $.ajax({
      method: 'POST',
      url: form.attr('action'),
      data: JSON.stringify(data),
      dataType: 'json',
      contentType: 'application/json',
    });

    request.then(() => {
      npsModal.removeClass('show');
    }).catch(() => {
      Alert.createAndShow({
        message: Lang.get('js/src/survey/SurveyNps.answer_sent_error'),
        type: 'danger'
      });
    });
  });
}

module.exports = {
  init: applySurveysEvents,
};
